// extracted by mini-css-extract-plugin
export default {"sizing":"HomeSizingOnboarding_sizing__WfWED","sizing__button":"HomeSizingOnboarding_sizing__button__cPKRx"};